import { useEffect, useState, useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { useLocation } from "react-router-dom";

export default function Transition({ children }) {
  const container = useRef();
  const location = useLocation();

  const [displayChildren, setDisplayChildren] = useState(children);
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    // If the path hasn't changed, skip the transition
    if (location.pathname === currentPath) return;

    // Animate out
    gsap.to(container.current, {
      opacity: 0,
      y: -30,
      duration: 0.5,
      ease: "power2.inOut",
      onComplete: () => {
        // Swap content
        setDisplayChildren(children);
        setCurrentPath(location.pathname);

        // Animate in
        gsap.set(container.current, { opacity: 0, y: 30 });
        gsap.to(container.current, {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: "power2.out",
        });
      },
    });
  }, [children, location.pathname, currentPath]);

  return <div ref={container}>{displayChildren}</div>;
}
